<template>
  <div :class="{'user-authenticated': authenticated, 'user-not-authenticated': !authenticated }"
       class="app-layout">
    <div class="container-fluid header-container mb-3">
      <div class="col-lg-6 m-auto border-1">
        <div class="header d-flex flex-column">
          <div class="row">
            <div class="col-10 text-left mt-4 mt-sm-3 mt-md-4 mb-2 mb-sm-4 mb-md-4">
              <a class="logo-1" href="/">
                <o-logo/>
              </a>
            </div>
          </div>
        </div>
        <div class="locale-container">
          <div class="locale-hint">{{ $t('medtastic.page_on') }}</div> <LocaleDropdown :right="true"/>
        </div>
      </div>
    </div>

    <div class="container-fluid content-container mb-3">
      <div id="content" class="col-lg-6 m-auto border-1">
        <o-child/>
      </div>
    </div>

    <event-contact v-if="$route.name === 'medtastic.event_detail'"></event-contact>

    <event-footer
        v-if="$route.name === 'medtastic.event_detail' || $route.name === 'medtastic.event_registration' || $route.name === 'medtastic.event_thanks'"></event-footer>

    <div v-else class="container-fluid footer-container">
      <div class="col-lg-6 m-auto border-1">
        <div class="row">
          <event-footer-text></event-footer-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from '~/components/LocaleDropdown'
import EventContact from '../pages/EventContact'
import EventFooter from '../pages/EventFooter'
import EventFooterText from '../pages/EventFooterText'
import OLogo from '~/components/Logo.vue'

export default {
  name: 'app-layout',

  data: () => ({
    sidebarVisible: false
  }),

  components: {
    OLogo,
    EventFooterText,
    EventFooter,
    EventContact,
    LocaleDropdown
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/check'
    }),
    year () {
      var d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
